(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[996],{

/***/ 37113:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/terms-of-use",
      function () {
        return __webpack_require__(12724);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ terms_of_use; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(3683);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/TermsOfUse/TermsOfUse.module.scss
var TermsOfUse_module = __webpack_require__(91636);
var TermsOfUse_module_default = /*#__PURE__*/__webpack_require__.n(TermsOfUse_module);
;// CONCATENATED MODULE: ./src/components/TermsOfUse/TermsOfUse.tsx





var TermsOfUse = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    (0,react.useLayoutEffect)(function() {
        window.addEventListener("contextmenu", function(e) {
            e.preventDefault();
        });
        return function() {
            return window.removeEventListener("contextmenu", function() {});
        };
    }, []);
    var handleCopy = function(e) {
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (TermsOfUse_module_default()).textWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "md",
            sx: {
                margin: "56px auto"
            },
            onCopy: handleCopy,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: t("footer.links.terms")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "NOTICE"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Please read these website terms of use carefully. By accessing this site, you agree to be bound by the following terms of use. If you do not agree to these terms of use, please do not access this site or any of its pages."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "INTELLECTUAL PROPERTY RIGHTS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: 'The copyright of the pages and screens displaying the pages, as well as the information and materials on them and their location, belongs to LEAD GATES LTD, a company registered in Bulgaria with its registered office at APT. 20, FL. 6, 14 MIZIYA STR., TOWN OF PLOVDIV under the brand "Smart Gates" (hereinafter referred to as "Smart Gates" "), unless otherwise indicated. The trademarks, logos and service marks displayed on this site are the property of Smart Gates, its Affiliates, Subsidiaries and Partners. Nothing on this site shall be construed as conferring, by implication, by estoppel or otherwise, any license or right to use any trademark, logo or service mark displayed on this site without the prior written permission of the owner of the mark. All the information and content available on the site is protected by copyright. Users of the Site are prohibited from modifying, copying, distributing, transmitting, displaying, publishing, selling, licensing, creating derivative works from or otherwise using any information and content on or through the Site for commercial, public or other unauthorized purposes.'
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "USE OF INFORMATION AND MATERIALS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "The information and materials contained on these pages, as well as the terms of use set forth herein, are subject to change without notice. Unauthorized use of the Website and Smart Gates systems or misuse of any information posted on the Site is strictly prohibited. Not all products and services are available in all geographic regions. Eligibility for certain products and services is subject to final determination by Smart Gates and/or its affiliates."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "LINKS AND REFERENCES"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "This site may contain links and/or links to websites (e.g., trademarks) controlled or offered by third parties not affiliated with Smart Gates. Smart Gates hereby disclaims any liability for any information, materials, products or services posted or offered on any third-party site. Smart Gates does not endorse or recommend any information, products or services offered on any third-party site, and Smart Gates is not responsible for any failure of products or services offered or advertised on any third-party site. Smart Gates is not responsible for the content of any such third-party site. Such third party may have a different privacy policy than that of Smart Gates, and such third-party site may provide less security than the Smart Gates site."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "NO WARRANTY"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: 'The information and materials contained on this site, including text, graphics, links or other elements, are provided "as is" "as available". Smart Gates does not warrant the accuracy, adequacy or completeness of this information and materials and expressly disclaims liability for errors or omissions in this information and materials. No warranties of any kind, implied, express or statutory, including but not limited to warranties of non-infringement, title, merchantability, fitness for a particular purpose and freedom from computer viruses, are given in conjunction with the information and materials, available on this website. Smart Gates assumes no responsibility for any errors or omissions in the content of this site.'
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "LIMITATION OF LIABILITY"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Under no circumstances shall Smart Gates be liable for any damages, including, without limitation, direct or indirect, special, incidental or consequential damages, damages or expenses, arising out of or in connection with this site or any linked site or its use or inability to use any party, or in connection with any failure or performance, error, omission, interruption, defect, delay in operation or transmission, computer virus or line or system failure, even if Smart Gates or its representatives are alerted to the possibility of such damage, loss or expense."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "SUBMISSIONS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "All information provided to Smart Gates through this site is considered and remains the property of Smart Gates, and Smart Gates is free to use any ideas, concepts, know-how or techniques contained in the information that a visitor to this site provides to Smart Gates through this site. Smart Gates has no obligation of confidentiality with respect to the information provided, except as agreed by a Smart Gates legal entity that has a direct relationship with customers, or as otherwise specifically mentioned in the Smart Gates Privacy Policy, or required by law. Nothing contained herein shall be construed as limiting or reducing Smart Gates' liability and obligations to customers under smart Gates' Privacy Policy."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "AVAILABILITY"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "This site is not intended for distribution or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to local law or regulation."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "CHANGES TO THE TERMS OF USE"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Smart Gates reserves the right to revise these Terms of Use at any time without notice. Users of the Site are deemed to be informed of and bound by any changes to these Terms of Use. You agree to review these Terms of Use regularly, and your continued access to or use of this Site constitutes your acceptance of any changes."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "GOVERNING LAW"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Users of this website hereby consent to the exclusive jurisdiction and venue of the courts of Bulgaria in all disputes (a) arising out of or relating to this website and/or these Terms of Use, (b) in which this website and/or these Terms of Use and/or these Terms of Use are a matter of fact."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "GENERAL"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Use of this site is unauthorized (a) in any manner that does not give full effect to all provisions of these Terms of Use and (b) any jurisdiction where use of this Site may violate any legal requirements. As a result of these Terms of Use or your use of this site, there is no joint venture, partnership, employment or agency relationship. These Terms of Use constitute the entire agreement between you and Smart Gates with respect to this site and supersede any previous or current communications and suggestions, whether electronic, oral or otherwise, between you and Smart Gates with respect to this site. No changes to these Terms of Use will be effective without the express permission of an official of Smart Gates."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "CONTACTING US"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "If you have any questions about these Terms of Use, please contact us at:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "support@smart-gates.net"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/doc/terms-of-use.tsx


var Page = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsOfUse, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var terms_of_use = (Page);


/***/ }),

/***/ 91636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"TermsOfUse_textWrapper__s7L6x"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(37113); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);